export default class GoogleImaDaiApiLoadError extends Error {
  constructor(message: string = 'Unable to load ima dai sdk') {
    super(message);
    this.name = 'GoogleImaDaiApiLoadError';
  }
}
